import { type MRT_Localization } from '..';

export const MRT_Localization_SR_CYRL_RS: MRT_Localization = {
  actions: 'Акције',
  and: 'и',
  cancel: 'Откажи',
  changeFilterMode: 'Промени режим филтрирања',
  changeSearchMode: 'Промени режим претраге',
  clearFilter: 'Поништи филтер',
  clearSearch: 'Поништи претрагу',
  clearSort: 'Поништи сортирање',
  clickToCopy: 'Кликни да копираш',
  collapse: 'Рашири',
  collapseAll: 'Рашири све',
  columnActions: 'Акције над колонама',
  copiedToClipboard: 'Копирани у clipboard',
  dropToGroupBy: 'Убаци у групу по {column}',
  edit: 'Измени',
  expand: 'Прошири',
  expandAll: 'Прошири све',
  filterArrIncludes: 'Укључује',
  filterArrIncludesAll: 'Укључује све',
  filterArrIncludesSome: 'Укључује',
  filterBetween: 'Између',
  filterBetweenInclusive: 'Инклузивно између',
  filterByColumn: 'Филтрирај по {column}',
  filterContains: 'Садржи',
  filterEmpty: 'Празно',
  filterEndsWith: 'Завршава се на',
  filterEquals: 'Једнако',
  filterEqualsString: 'Једнако',
  filterFuzzy: 'Фази',
  filterGreaterThan: 'Веће',
  filterGreaterThanOrEqualTo: 'Веће или једнако',
  filterInNumberRange: 'Између',
  filterIncludesString: 'Садржи',
  filterIncludesStringSensitive: 'Садржи',
  filterLessThan: 'Мање',
  filterLessThanOrEqualTo: 'Мање или једнако',
  filterMode: 'Режим филтрирања: {filterType}',
  filterNotEmpty: 'Није празно',
  filterNotEquals: 'Није једнако',
  filterStartsWith: 'Почиње са',
  filterWeakEquals: 'Једнако',
  filteringByColumn: 'Филтрирање по {column} - {filterType} {filterValue}',
  goToFirstPage: 'Иди на прву страницу',
  goToLastPage: 'Иди на последњу страницу',
  goToNextPage: 'Иди на следећу страницу',
  goToPreviousPage: 'Иди на прошлу страницу',
  grab: 'Зграби',
  groupByColumn: 'Групиши по {column}',
  groupedBy: 'Груписано по ',
  hideAll: 'Сакриј све',
  hideColumn: 'Сакриј {column} колону',
  max: 'Макс',
  min: 'Мин',
  move: 'Помери',
  noRecordsToDisplay: 'Нема редова за приказ',
  noResultsFound: 'Нема резултата',
  of: 'од',
  or: 'или',
  pinToLeft: 'Закачи лево',
  pinToRight: 'Закачи десно',
  resetColumnSize: 'Ресетуј ширину колоне',
  resetOrder: 'Ресетуј поредак',
  rowActions: 'Акције над редовима',
  rowNumber: '#',
  rowNumbers: 'Број редова',
  rowsPerPage: 'Редова по страници',
  save: 'Сними',
  search: 'Претражи',
  selectedCountOfRowCountRowsSelected:
    '{selectedCount} од {rowCount} редова означено',
  select: 'Означи',
  showAll: 'Прикажи све',
  showAllColumns: 'Прикажи све колоне',
  showHideColumns: 'Прикажи/сакриј колоне',
  showHideFilters: 'Прикажи/сакриј филтере',
  showHideSearch: 'Прикажи/сакриј претрагу',
  sortByColumnAsc: 'Сортирај по {column} растуће',
  sortByColumnDesc: 'Сортирај по {column} опадајуће',
  sortedByColumnAsc: 'Сортирано по {column} растуће',
  sortedByColumnDesc: 'Сортирано по {column} опадајуће',
  thenBy: ', онда по ',
  toggleDensity: 'Подеси густину',
  toggleFullScreen: 'Укључи/искључи преко целог екрана',
  toggleSelectAll: 'Означи/одзначи све редове',
  toggleSelectRow: 'Означи/одзначи ред',
  toggleVisibility: 'Укључи/искључи видљивост',
  ungroupByColumn: 'Одгрупиши по {column}',
  unpin: 'Откачи',
  unpinAll: 'Откачи све',
  unsorted: 'Несортирано',
};
